import classes from './Footer.module.css';
const Footer = function(){
    return(
        <footer className={classes.footer}>
            <p>Made by Himanshu Rawat © 2022-23</p>
        </footer>
    )
}

export default Footer;